import React from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryTags } from "../story-page-components/story-tags.js";
import { RelatedStories } from "../story-page-components/related-stories.js";
import { StoryPageCard } from "../story-page-components/story-page-card.js";
import { DfpAd } from "../dfp-ad";
import { MetypeCommentingWidget } from "@metype/components";
import { breakpoint } from "../../../utils/breakpoint";
import { addTargetBlankToExtLinks } from "../../../utils/add-target-blank-to-extlinks";

function renderMetype(story, metypeConfig, previewStory = false) {
  if(previewStory || isEmpty(metypeConfig)) return null;

  return <MetypeCommentingWidget
    host={metypeConfig.host}
    accountId={metypeConfig.accountId}
    pageURL={generateHostUrl(story)}
    primaryColor={metypeConfig.primaryColor} />
}

function BlankStoryTemplate(props) {
  const {config: {'metype-config':metypeConfig = {}, 'cdn-image':cdnImage = ''} = {}} = props;
  const StoryCards = props.story.cards.map((card, index) => {
    if(index === 0) {
      return <div key={card.id} className="blank-story__card--with-ad">
        <StoryPageCard key={card.id} card={card} story={props.story} cdn={cdnImage}/>
        <div className="app-ad app-ad--story-horizontal">
          <DfpAd adtype="Story-Middle-Ad"/>
        </div>
      </div>
    } else {
        return <StoryPageCard key={card.id} card={card} story={props.story} cdn={cdnImage}/>
    }
  });
  const isReviewStory = props.story["story-template"] === 'review';

  const imageElement = breakpoint('tablet') ?
    <ResponsiveHeroImage story={props.story}
    aspectRatio={[16,9]}
    defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
    imgParams={{auto:['format', 'compress'], fit:'max'}} /> : 
    <ResponsiveHeroImage story={props.story}
    aspectRatio={[9,3]}
    defaultWidth={480} widths={[250,480,640,960,1200]} sizes="(max-width: 500px) 98%"
    imgParams={{auto:['format', 'compress'], fit:'max'}} />;
  return <article className="blank-story">
        {
          props.story["hero-image-s3-key"] ?
          <figure className="blank-story-hero-image qt-image-16x9">
            {imageElement}
          </figure>:
          <div className="blank-story-hero-image__fallback-placeholder">
          </div>
        }
      <div className="blank-story--wrapper">
        <div className="blank-story--content">
          <StoryHeaderCard story={props.story}/>
        { isReviewStory && (
          <div className="rating__wrapper">
            <h5 className="rating__title">{get(props.story, ['metadata','review-title'])} <span className="rating__value">({get(props.story, ['metadata','review-rating', 'value'])} / 5)</span></h5>
            <div className="rating">
              <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />
            </div>
          </div>
          )}
          {StoryCards}
          <StoryTags tags={props.story.tags} config={props.config}/>
          <div className="blank-story__aside">
            <div className="app-ad app-ad--story-mrec">
              <DfpAd adtype="Story-Mrec"/>
            </div>
            <RelatedStories story={props.story}></RelatedStories>
          </div>
        </div>
        { !props.preview && <div>
            <div className="app-ad app-ad--story-horizontal">
              <DfpAd adtype="Story-Bottom-Ad"/>
            </div>
            <div className="blank-story--metype-widget">
              {renderMetype(props.story, metypeConfig, props.preview)}
            </div>
          </div>
        }
      </div>
    </article>
}



function generateHostUrl(story = {}){
  if(global.location){
    return `${global.location.origin}/${story.slug}`;
  }
}


class BlankStory extends React.Component {
  componentDidMount() {
    addTargetBlankToExtLinks(this.storyWrapperElement);
  }
  render() {
    return <div className={`story-grid`} ref={(el) => this.storyWrapperElement = el}>
      <BlankStoryTemplate {...this.props}></BlankStoryTemplate>
    </div>
  }
}

export { BlankStory };
